export const titleOptions = [
	{ value: "M", label: "M" },
	{ value: "MME", label: "MME" },
];
